// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3mQM0{overflow:auto;width:100%}.P_ZzL{background:#fff;border-radius:16px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:16px;overflow-y:auto;padding:2rem 1.6rem}._2tdzK{background:#fff;border-radius:1rem;padding:1.2rem;text-align:center}.cgY2J{font-size:20px;font-size:2rem;font-weight:500}div.DnuqH{margin-top:auto;-ms-flex-negative:0;flex-shrink:0;padding:0 20px}div.DnuqH .pagination-pages{background:#fff}", ""]);
// Exports
exports.locals = {
	"container": "_3mQM0",
	"contentBox": "P_ZzL",
	"infoContainer": "_2tdzK",
	"infoHeader": "cgY2J",
	"pagination": "DnuqH"
};
module.exports = exports;
